import React, { type ComponentType } from 'react';
import { ActOneBeforeSlide } from './components/slides/ActOneBeforeSlide';
import { ActThreeAfterSlide } from './components/slides/ActThreeAfterSlide';
import { ActTwoDuringSlide } from './components/slides/ActTwoDuringSlide';
import { AisleToConversationSlide } from './components/slides/AisleToConversationSlide';
import { BonusEncoreSlide } from './components/slides/BonusEncoreSlide';
import { CongressJourneySlide } from './components/slides/CongressJourneySlide';
import { EncoreSlide } from './components/slides/EncoreSlide';
import { FinaleSlide } from './components/slides/FinaleSlide';
import { FirstProductionSlide } from './components/slides/FirstProductionSlide';
import { FullPlaySlide } from './components/slides/FullPlaySlide';
import { IdeasTravelSlide } from './components/slides/IdeasTravelSlide';
import { LoveSlide } from './components/slides/LoveSlide';
import { MainPerformanceSlide } from './components/slides/MainPerformanceSlide';
import { OpeningSceneSlide } from './components/slides/OpeningSceneSlide';
export type DeckSlide = {
  id: string;
  title: string;
  component: ComponentType;
};
export const slides: DeckSlide[] = [{
  id: 'scr_axxh2o',
  title: 'ALL YOU NEED IS LOVE.',
  component: LoveSlide
}, {
  id: 'scr_ijcf77',
  title: 'A CONGRESS IS NOT 3 DAYS.',
  component: CongressJourneySlide
}, {
  id: 'scr_uf0617',
  title: 'SET THE SCENE',
  component: ActOneBeforeSlide
}, {
  id: 'scr_ezxig3',
  title: 'PLANT THE FIRST QUESTION.',
  component: OpeningSceneSlide
}, {
  id: 'scr_9g32gw',
  title: 'CREATE THE CONVERSATION',
  component: ActTwoDuringSlide
}, {
  id: 'scr_1zcuqq',
  title: 'FROM AISLE TO CONVERSATION',
  component: AisleToConversationSlide
}, {
  id: 'scr_spc9t0',
  title: 'ASK FIRST. PRESENT SECOND.',
  component: MainPerformanceSlide
}, {
  id: 'scr_r4o317',
  title: 'IDEAS TRAVEL.',
  component: IdeasTravelSlide
}, {
  id: 'scr_wy4l9u',
  title: 'TURN IDEAS INTO ACTION',
  component: ActThreeAfterSlide
}, {
  id: 'scr_taz790',
  title: 'GIVE THE KNOWLEDGE BACK.',
  component: EncoreSlide
}, {
  id: 'scr_8x451y',
  title: 'ONE CONTINUOUS CONVERSATION.',
  component: FullPlaySlide
}, {
  id: 'scr_uqjkcj',
  title: 'START SMALL. CONNECT THE THREE ACTS.',
  component: FirstProductionSlide
}, {
  id: 'scr_ucf396',
  title: 'WE COULDN’T BRING EVERYONE TO ECCO.',
  component: BonusEncoreSlide
}, {
  id: 'scr_mu75p2',
  title: 'LET’S START WITH THE FIRST QUESTION.',
  component: FinaleSlide
}];